import { styled, keyframes } from "@mui/material";

export const HeroSection = styled("section")<{
  backgroundColor: string;
}>(({ backgroundColor }) => ({
  backgroundColor: backgroundColor,
  overflow: "hidden",
  position: "relative",
}));

const scrollAnimationDesktop = keyframes`
0%, 25% {
   top: -17.8rem;
  }
25%, 50% {
    top: -12rem;
  }
50%, 75% {
  top: -6.5rem;
  }
75%, 100%{
  top: -1.2rem;
  }
`;

const scrollAnimationMobile = keyframes`
0%, 25% {
  top: -13rem;
  }
25%, 50% {
    top: -9rem;
  }
50%, 75% {
    top: -5rem;
  }
75%, 100%{
    top: -0.5rem;
  }
`;

export const SubtitleList = styled("div")(({ theme }) => ({
  position: "absolute",
  [theme.breakpoints.up("md")]: {
    animation: `${scrollAnimationDesktop} 5s infinite`,
  },
  [theme.breakpoints.down("md")]: {
    animation: `${scrollAnimationMobile} 5s infinite`,
  },
}));

const transformBGAnimationDesktopOwner = keyframes`
0%, 25% {
  width: 75%
  }
25%, 50% {
  width: 70%
  }
50%, 75% {
width: 90%
  }
75%, 100%{
width: 75%
}
`;

const transformBGAnimationDesktopTenant = keyframes`
0%, 25% {
  width: 75%
  }
25%, 50% {
  width: 70%
  }
50%, 75% {
width: 60%
  }
75%, 100%{
width: 75%
}
`;

const transformBGAnimationMobileOwner = keyframes`
0%, 25% {
  width: 85%
  }
25%, 50% {
  width: 80%
  }
50%, 75% {
width: 105%
  }
75%, 100%{
width: 85%
}
`;

const transformBGAnimationMobileTenant = keyframes`
0%, 25% {
  width: 85%
  }
25%, 50% {
  width: 80%
  }
50%, 75% {
width: 70%
  }
75%, 100%{
width: 85%
}
`;

export const SubtitleContainer = styled("div")<{
  color: string;
  ownership: "owner" | "tenant";
}>(({ color, ownership, theme }) => ({
  overflow: "hidden",
  position: "relative",
  height: "12%",
  marginLeft: "10px",
  paddingLeft: "14px",
  marginTop: "10px",
  backgroundColor: color,
  borderRadius: "48px",
  minHeight: "50px",
  [theme.breakpoints.up("md")]: {
    animation: `${
      ownership === "owner"
        ? transformBGAnimationDesktopOwner
        : transformBGAnimationDesktopTenant
    } 5s infinite`,
  },
  [theme.breakpoints.down("md")]: {
    animation: `${
      ownership === "owner"
        ? transformBGAnimationMobileOwner
        : transformBGAnimationMobileTenant
    } 5s infinite`,
  },
}));
